module.exports = __webpack_public_path__ + "static/media/introduce-3.e02b02d5.png";